module.exports = __webpack_public_path__ + "static/lindsay_epstein-77e35405d03156c2f858a91e8d7ba9dc.jpg";